<div class="form-group">
  <div class="custom-file img-upload">
    <input type="file" #fileInput (change)="fileChangeEvent($event)" class="input-file">
    @if ((fileType === 'image/png' || fileType === 'image/jpeg') && !fileError) {
      <div class="img-content">
        @if (FormControl?.value) {
          <img [src]="FormControl?.value" alt="preview-image"/>
        } @else {
          <div class="empty-content file-container">
            <em class="fa fa-fw fa-file-upload fa-2x"></em>
          </div>
        }
      </div>
    } @else {
      <div class="empty-content file-container">
        <em class="fa fa-fw fa-file-upload fa-2x"></em>
      </div>
    }
  </div>
  @if (fileError) {
    <div class="text-warning">{{ fileError }}</div>
  }
</div>

@if (FormControl?.value && !fileError) {
  <button class="btn btn-danger" (click)="removeFile()">{{ removeLabel | translate }}</button>
}
